import {
  EventEmitter,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  Output,
  Input,
  OnInit
} from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { MenuItems } from '../../../shared/menu-items/menu-items';
import { CommonService } from '../../../shared/common.service';
import { StreamService } from '../../../../app/shared/stream.service';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

export class AppSidebarComponent implements OnInit, OnDestroy {

  mainMenuItems = [
    { state: 'dashboard', name: 'Dashboard', iconUrl:"assets/images/dashboard.svg", type: 'link', iconUrlActive:'assets/images/dashboard-white.svg'},
    { state: 'user', name: 'Members', iconUrl:"assets/images/users.svg", type: 'link', iconUrlActive:'assets/images/users-white.svg'},
    { state: 'concierge', name: 'Concierge', iconUrl:"assets/images/consigne.svg", type: 'link', iconUrlActive:'assets/images/consigne.svg'},
    // { state: 'staff', name: 'Staff', iconUrl:"assets/images/staff.svg", type: 'link', iconUrlActive:'assets/images/staff.svg'},
   
    { state: 'service', name: 'Services', iconUrl:"assets/images/service.svg", type: 'link', iconUrlActive:'assets/images/service-white.svg'},
    { state: 'service/service-list-emergency', name: 'Urgent Services', iconUrl:"assets/images/urgent.svg", type: 'link', iconUrlActive:'assets/images/urgent.svg'},
    { state: 'space/space-list', name: 'Space', iconUrl:"assets/images/room.svg", type: 'link', iconUrlActive:'assets/images/room-white.svg'},
    { state: 'bookings', name: 'Bookings', iconUrl:"assets/images/booking.svg", type: 'link', iconUrlActive:'assets/images/booking-white.svg'},
    { state: 'events', name: 'Events', iconUrl:"assets/images/event.svg", type: 'link', iconUrlActive:'assets/images/event-white.svg'},
    
  ];

  @Output() messageEvent = new EventEmitter<string>();
  @Output() menuItemClicked = new EventEmitter<Event>();
  @Input() isMobileActive: any;
  mobileQuery: MediaQueryList;
  isAllow: boolean = false;
  isPodcast: boolean = false;
  currentNavition = [];
  userData: any;
  userP: any;
  userG: any;
  userName: any
  podcastVal: boolean = false;
  private _mobileQueryListener: () => void;
  decodedToken: any;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    public common: CommonService,
    private streamService: StreamService,
    public router: Router,
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event.url.startsWith('/main')) {
          this.menuItems;

        }
      }
    });
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
  
    this.userData = JSON.parse(localStorage.getItem("userData"));
    if (this.userData.userType == 'admin') {
      this.currentNavition = this.mainMenuItems;
    }


  }

  sendRouteVal(index) {
    this.streamService.streamMessage(index);
    // this.messageEvent.emit(index);
  }


  activeRoute(index, event?: Event) {
    localStorage.setItem("activeIndex", index);
    this.sendRouteVal(index);
    if (event) {
      this.menuItemClicked.emit(event);
    }
  }

  readLocalStorageValue(key: string): number {
    return parseInt(localStorage.getItem(key));
  }

  logOut() {
    this.common.logOut();
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  navigateHome(){

    localStorage.setItem("activeIndex", '0');
    this.sendRouteVal(0);
    this.router.navigate(['/dashboard']);
  }

  navigateUserList(){
    localStorage.setItem("activeIndex", '1');
    this.sendRouteVal(1);
    this.router.navigate(['/user-list']);
  }

  navigateServiceList(){
    localStorage.setItem("activeIndex", '2');
    this.sendRouteVal(2);
    this.router.navigate(['/service-list']);
  }

  navigateRoomList(){
    localStorage.setItem("activeIndex", '3');
    this.sendRouteVal(3);
    this.router.navigate(['/room-list']);
  }
}
